import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({templateUrl: './paylayout.component.html'})
export class PaylayoutComponent {

  constructor(
    private router: Router,

) {

}

}
